import { useItem } from './cache.js';
import callAndSuspend from './callAndSuspend.js';
import normalizeArgs from './normalizeArgs.js';
import useUpdaters from './useUpdaters.js';
export default normalizeArgs(function useAsyncSafe(...args) {
    const memoized = useItem(...args);
    useUpdaters(memoized);
    if (memoized.value) {
        return memoized.value;
    }
    if (!memoized.suspender) {
        callAndSuspend(args, memoized);
    }
    throw memoized.suspender;
});
//# sourceMappingURL=useAsyncSafe.js.map